import { render, staticRenderFns } from "./ViewWebsite.vue?vue&type=template&id=560159ce&"
import script from "./ViewWebsite.vue?vue&type=script&lang=ts&"
export * from "./ViewWebsite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports